import { Reels } from '@nolimitcity/slot-game/bin/core/reel/reelarea/Reels';
import { BFNudgeStackedWPController } from './../../winpresentation/nudgeStacked/BFNudgeStackedWPController';
import { NudgeSpinReelController } from "@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeSpinReelController";
import { BarbarianFuryParsedGameData } from "../../server/data/BarbarianFuryParsedGameData";
import { IReelStopSpinData } from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import { INudgeParsedGameData } from '@nolimitcity/slot-game/bin/game/reel/nudgereel/NudgeParsedGameData';

export class BarbarianFuryReelController extends NudgeSpinReelController {
    private _noNudgeReel: number[] = [];

    /**
     * Override parseDoNudge method to add isScatterNudge condition
     * will fix the fake reel set on top in scatter nudge.
     * @param data
     */
    protected parseDoNudge(data: BarbarianFuryParsedGameData): boolean {
        const isReelNudge: boolean = (data.doReelNudge != null && data.doReelNudge[this._reelId] != null) ? data.doReelNudge[this._reelId] : false;
        const isScatterNudge: boolean = (data.doScatterNudge != null && data.doScatterNudge[this._reelId] != null) ? data.doScatterNudge[this._reelId] : false;
        return isReelNudge || isScatterNudge;
    }


    public onGameDataParsed(data: INudgeParsedGameData): void {
        super.onGameDataParsed(data);
        this._noNudgeReel = [];
        // did it to get last spinning reel from initialStackOverlay.
        if (data.mode.indexOf("RESPIN") !== -1) {
            let arr: number[] = [0, 1, 2, 3, 4];
            for (let index = 0; index < BFNudgeStackedWPController._nudgeData!.initialStackOverlay.length - 1; index++) {
                if (BFNudgeStackedWPController._nudgeData!.initialStackOverlay[index]) {
                    arr.splice(arr.indexOf(index), 1);
                }
            }
            this._noNudgeReel = arr;
        }
    }
    /**
     * override this function to add extra delay on last reel of reelspin.
     * @param stopSpinData 
     */
    protected getStopDelayDelta(stopSpinData: IReelStopSpinData): number {
        //  added this check to add delay on last spinning reel in Respin.
        if (this._gameMode.indexOf("RESPIN") !== -1 && this._reelId === this._noNudgeReel[this._noNudgeReel.length - 1] && this._noNudgeReel.length === 2) {
            for (let i = 0; i < 5; i++) {
                let sym = Reels.getSymbol(this._noNudgeReel[this._noNudgeReel.length - 2], i)
                if (sym!.symName.indexOf("M") !== -1) {
                    return (super.getStopDelayDelta(stopSpinData) * 1.5);
                }
            }
        }
        return super.getStopDelayDelta(stopSpinData);
    }

}